<template>
  <div>
    <Breadcrumb msg1="会员管理" msg2="会员详情" />
    <el-card v-if="data.member">
      <div style="margin-bottom: 10px">
        <el-button icon="el-icon-back" @click="$router.back()">返回</el-button>
      </div>
      <el-row :gutter="10">
        <el-col :span="6"><div class="stat"><div class="num">¥{{ data.member.balance || 0 }}</div><div class="sub">账户余额</div></div></el-col>
        <el-col :span="6"><div class="stat"><div class="num">{{ data.member.points || 0 }}</div><div class="sub">积分</div></div></el-col>
        <el-col :span="6"><div class="stat"><div class="num">¥{{ data.member.totalRecharge || 0 }}</div><div class="sub">累计储值</div></div></el-col>
        <el-col :span="6"><div class="stat"><div class="num">{{ data.level.name || '-' }}</div><div class="sub">会员等级</div></div></el-col>
      </el-row>
      <el-descriptions :column="3" border style="margin-top: 15px" v-if="data.customer">
        <el-descriptions-item label="姓名">{{ data.customer.name }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ data.customer.phone }}</el-descriptions-item>
        <el-descriptions-item label="标签">{{ data.customer.tags }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card style="margin-top: 10px">
      <el-tabs v-model="tab">
        <el-tab-pane label="储值流水" name="recharge">
          <el-table :data="recharges" border size="small">
            <el-table-column prop="rechargeTime" label="时间" width="160"></el-table-column>
            <el-table-column prop="amount" label="充值金额" width="100"></el-table-column>
            <el-table-column prop="giftAmount" label="赠送金额" width="100"></el-table-column>
            <el-table-column prop="payMethod" label="支付方式" width="100"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="积分流水" name="point">
          <el-table :data="pointLogs" border size="small">
            <el-table-column prop="createTime" label="时间" width="160"></el-table-column>
            <el-table-column prop="type" label="类型" width="100"></el-table-column>
            <el-table-column prop="change" label="积分变动" width="100"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="优惠券" name="coupon">
          <el-table :data="coupons" border size="small">
            <el-table-column prop="couponId" label="券模板ID" width="100"></el-table-column>
            <el-table-column prop="status" label="状态" width="100"></el-table-column>
            <el-table-column prop="getTime" label="领取时间" width="160"></el-table-column>
            <el-table-column prop="useTime" label="使用时间" width="160"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      id: this.$route.params.id,
      tab: 'recharge',
      data: { member: null, customer: null, level: {} },
      recharges: [],
      pointLogs: [],
      coupons: []
    }
  },
  created () {
    this.$axios.http.get(`/members/${this.id}`).then(res => {
      if (res.data.status === 200) {
        this.data = { member: res.data.data.member, customer: res.data.data.customer, level: res.data.data.level || {} }
      }
    })
    this.$axios.http.get('/memberRecharges', { params: { page: 1, limit: 20, member_id: this.id } }).then(r => {
      if (r.data.status === 200) this.recharges = r.data.data.records || []
    })
    this.$axios.http.get('/memberPointLogs', { params: { page: 1, limit: 20, member_id: this.id } }).then(r => {
      if (r.data.status === 200) this.pointLogs = r.data.data.records || []
    })
    this.$axios.http.get(`/memberCoupons/member/${this.id}`).then(r => {
      if (r.data.status === 200) this.coupons = r.data.data || []
    })
  }
}
</script>

<style scoped>
.stat { background: #f5f7fa; border-radius: 4px; padding: 14px; text-align: center; }
.num { font-size: 22px; color: #409EFF; font-weight: bold; }
.sub { color: #909399; font-size: 13px; margin-top: 4px; }
</style>
